module.exports = __webpack_public_path__ + "static/media/galdisa_acerca_de_tiempo_2009.77ab2650.jpg";